import { Box, withStyles } from '@material-ui/core';
import { SRoundedContainer } from '@setvi/shared/components';
import { CSSProperties } from 'react';

export const PageContainer = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
})(Box);

export const HiddenScroll = withStyles({
  root: {
    overflow: 'auto',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      display: 'none !important'
    }
  }
})(Box);

export const ContentContainer = withStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F8F9FA'
  }
})(Box);

export const InfoContainer = withStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F8F9FA'
  }
})(Box);

export const TabContentContainer = withStyles({
  root: { width: '100%', overflow: 'hidden auto' }
})(SRoundedContainer);

export const ImageWrapper = withStyles(({ spacing }) => ({
  root: {
    height: 360,
    padding: spacing(2),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))(Box);

export const imageStyle = {
  height: '100%',
  maxHeight: 345,
  maxWidth: 380,
  width: '100%'
} as CSSProperties;

export const AskAIButton = withStyles({
  root: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    borderRadius: 120,
    padding: 2,
    background:
      'linear-gradient(180deg, #1E96FC 0%, #7E44FC 31.5%, #57CCF0 100%)',
    display: 'inline-block',

    '& button': {
      borderRadius: 'inherit',
      background: '#f8f9fa',

      '&:hover': {
        background: '#f8f9fa'
      }
    }
  }
})(Box);
